import { render, staticRenderFns } from "./dataSourceAxis.vue?vue&type=template&id=8bf6294c&scoped=true&"
import script from "./dataSourceAxis.vue?vue&type=script&lang=js&"
export * from "./dataSourceAxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf6294c",
  null
  
)

export default component.exports